/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import axios from 'axios'
import config from './../config'

export class Interfaces {
  static getRegularFields(params) {
    const url = process.env.NODE_ENV == "development"
      ? [
        "http://10.252.25.208:8080/castlemock/mock/rest/project/ViXRbO/application/VgCY5v/interface_id",
      ]
      : [config.basename, 'api/v1/interface', params.csId].join('/')
    return axios.get(url + "?isGroup=" + params.isGroup)
  }

  static getMetricFields(params) {
    const id = params.get("cs_id")
    var url = process.env.NODE_ENV == "development"
      ? [
        "http://10.252.25.208:8080/castlemock/mock/rest/project/ViXRbO/application/VgCY5v/interface/metric",
      ]
      : [config.basename, 'api/v1/interface/metric', id != null ? id : '']
    return axios.post(url.join('/'), params)
  }

  static getMasterElements(filter) {
    const url = [config.basename, 'api/v1/interface'].join('/')
    if (filter) {
      return axios.get(url + "?q=" + filter)
    } else {
      return axios.get(url)
    }
  }

  static updateAliasInterface(newAlias, master_id) {
    return axios.put(
      [config.basename, `api/v1/interface/update/${master_id}?name=${newAlias}`].join("/")
    );
  }

  static getInterfaceAlias(master_id) {
    return axios.get(
      [config.basename, `api/v1/interface/getAlias/${master_id}`].join("/")
    );
  }
}
